import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import BeachAccessOutlinedIcon from '@mui/icons-material/BeachAccessOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import FingerprintOutlinedIcon from '@mui/icons-material/FingerprintOutlined';
import MoreTimeOutlinedIcon from '@mui/icons-material/MoreTimeOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import EmojiPeopleOutlinedIcon from '@mui/icons-material/EmojiPeopleOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import type { NavEntry, NavGroup, NavItem } from '@/navigation/navItems';
import { Perm } from '@/auth/permissions';
import { Modules } from '@/core/modules/moduleKeys';

const item = (label: string, path: string, icon: NavItem['icon'], comingSoon?: boolean): NavItem =>
  ({ label, path, icon, module: Modules.Hr, permission: Perm.Hr.View, ...(comingSoon ? { comingSoon } : {}) });

/**
 * The HR module's navigation: one collapsible menu with the areas an HR office works in. Shown only
 * where the organisation has the module on. It grows an entry per area as each one lands; the
 * sidebar prunes anything the person cannot see, so a reader with no HR rights sees no menu at all.
 */
export const hrNavEntries: NavEntry[] = [
  item('Overview', '/hr', BadgeOutlinedIcon),
  {
    kind: 'group', key: 'hr-people', label: 'People', icon: GroupsOutlinedIcon,
    items: [
      item('Employees', '/hr/people/employees', GroupsOutlinedIcon),
      item('Structure', '/hr/people/structure', AccountTreeOutlinedIcon),
      item('Personnel Actions', '/hr/people/actions', EditNoteOutlinedIcon),
    ],
  },
  {
    kind: 'group', key: 'hr-leave', label: 'Leave', icon: BeachAccessOutlinedIcon,
    items: [
      item('Leave Requests', '/hr/leave/requests', EventAvailableOutlinedIcon),
      item('Leave Balances', '/hr/leave/balances', BalanceOutlinedIcon),
      item('Public Holidays', '/hr/leave/holidays', CelebrationOutlinedIcon),
    ],
  },
  {
    kind: 'group', key: 'hr-time', label: 'Time', icon: ScheduleOutlinedIcon,
    items: [
      item('Attendance', '/hr/time/attendance', FingerprintOutlinedIcon),
      item('Overtime', '/hr/time/overtime', MoreTimeOutlinedIcon),
    ],
  },
  {
    kind: 'group', key: 'hr-payroll', label: 'Payroll', icon: PaymentsOutlinedIcon,
    items: [
      item('Payroll Runs', '/hr/payroll/runs', ReceiptLongOutlinedIcon),
      item('Payroll Processing', '/hr/payroll/processing', EventRepeatOutlinedIcon),
      item('Loans & Advances', '/hr/payroll/loans', RequestQuoteOutlinedIcon),
      item('Returns & Liability', '/hr/payroll/output', AccountBalanceOutlinedIcon),
      item('Payroll Set-up', '/hr/payroll/setup', TuneOutlinedIcon),
    ],
  },
  item('Recruitment', '/hr/recruitment', PersonSearchOutlinedIcon),
  item('Performance & Training', '/hr/development', SchoolOutlinedIcon),
  item('Employee Relations', '/hr/relations', GavelOutlinedIcon),
  item('Compliance', '/hr/compliance', PolicyOutlinedIcon),
  item('Employee experience', '/hr/experience', EmojiPeopleOutlinedIcon),
  item('Workforce & Insight', '/hr/workforce', InsightsOutlinedIcon),
  item('HR Reports', '/hr/reports', AssessmentOutlinedIcon),
  item('HR Settings', '/hr/settings', SettingsOutlinedIcon),
];

export const hrNavGroup: NavGroup = {
  kind: 'group', key: 'hr', label: 'HR & Payroll', icon: BadgeOutlinedIcon, items: hrNavEntries,
};
